import TestDataAPIInterface from './components/TestDataAPIInterface';

function App() {
  return (
    <div className="App">
      <TestDataAPIInterface />
    </div>
  );
}

export default App;